import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeView from '../views/HomeView.vue'
const originalPush = VueRouter.prototype.push;
 
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


Vue.use(VueRouter)

const routes = [{
		path: '/',
		name: '',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/index.vue')
	},
	{
		path: '/index',
		name: 'index',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/index.vue')
	},
	{
		path: '/introduce/authentication',
		name: 'introduce/authentication',
		component: () => import( /* webpackChunkName: "about" */ '../views/introduce/authentication.vue')
	},
	{
		path: '/introduce/reward',
		name: 'introduce/reward',
		component: () => import( /* webpackChunkName: "about" */ '../views/introduce/reward.vue')
	},
	{
		path: '/introduce/evaluate',
		name: 'introduce/evaluate',
		component: () => import( /* webpackChunkName: "about" */ '../views/introduce/evaluate.vue')
	},
	{
		path: '/introduce/history',
		name: 'introduce/history',
		component: () => import( /* webpackChunkName: "about" */ '../views/introduce/history.vue')
	},
	{
		path: '/solution/newEnergy',
		name: 'solution/newEnergy',
		component: () => import( /* webpackChunkName: "about" */ '../views/solution/newEnergy.vue')
	},
	{
		path: '/compete/index',
		name: 'compete/index',
		component: () => import( /* webpackChunkName: "about" */ '../views/compete/index.vue')
	},
	{
		path: '/compete/experiment',
		name: 'compete/experiment',
		component: () => import( /* webpackChunkName: "about" */ '../views/compete/experiment.vue')
	},
	{
		path: '/news/center',
		name: 'news/center',
		component: () => import( /* webpackChunkName: "about" */ '../views/news/center.vue')
	},
	{
		path: '/news/area',
		name: 'news/area',
		component: () => import( /* webpackChunkName: "about" */ '../views/news/area.vue')
	},
	{
		path: '/news/details',
		name: 'news/details',
		component: () => import( /* webpackChunkName: "about" */ '../views/news/details.vue')
	},
	{
		path: '/plan/plan',
		name: 'plan/plan',
		component: () => import( /* webpackChunkName: "about" */ '../views/plan/plan.vue')
	},
	{
		path: '/relation/relation',
		name: 'relation/relation',
		component: () => import( /* webpackChunkName: "about" */ '../views/relation/relation.vue')
	},
	{
		path: '/contact/contact',
		name: 'contact/contact',
		component: () => import( /* webpackChunkName: "about" */ '../views/contact/contact.vue')
	},
]

const router = new VueRouter({
	routes
})

export default router
